
export default function TwoPaths() {
  const paths = [
    {
      title: 'Entry Path',
      icon: 'ri-door-open-line',
      features: [
        'No prior experience required',
        'Learn simple health & selling skills',
        'Start earning while learning',
        'Weekly support & mentorship',
      ],
    },
    {
      title: 'Leadership Path',
      icon: 'ri-team-line',
      features: [
        'Build and lead business teams',
        'Advanced income & duplication strategy',
        'Leadership training & mentoring',
        'Long-term wealth & impact',
      ],
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Two Paths. One System.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {paths.map((path, index) => (
            <div
              key={index}
              className="bg-stone-50 rounded-xl p-8 hover:bg-stone-100 transition-all duration-300 transform hover:scale-105 border-2 border-amber-500"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-amber-500 rounded-full mb-6 mx-auto">
                <i className={`${path.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                {path.title}
              </h3>
              <ul className="space-y-4">
                {path.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-amber-500 text-xl"></i>
                    </div>
                    <span className="text-gray-600 ml-3">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="text-lg sm:text-xl text-amber-600 text-center font-semibold">
          You don't buy your way into leadership — you grow into it.
        </p>
      </div>
    </section>
  );
}
